import { render } from "./PicbookTransfrom.vue?vue&type=template&id=62026a0f&scoped=true"
import script from "./PicbookTransfrom.vue?vue&type=script&lang=js"
export * from "./PicbookTransfrom.vue?vue&type=script&lang=js"

import "./PicbookTransfrom.vue?vue&type=style&index=0&id=62026a0f&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62026a0f"]])

export default __exports__